var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.accounts),function(account){return _c('AccountListItem',{key:account.id,attrs:{"account":account},nativeOn:{"click":function($event){return _vm.changeAccount(account.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }